import { jsx as _jsx } from "react/jsx-runtime";
import { useImperativeHandle, useMemo, useRef, forwardRef } from 'react';
import { useMergeRefs } from '@floating-ui/react';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { useId } from '../../hooks/useId';
import { useControlledValue } from '../../hooks/useControlledValue';
import { Base } from '../Base';
import { RadioGroupContext, } from './RadioGroup.context';
// https://github.com/mui/material-ui/blob/master/packages/mui-material/src/RadioGroup/RadioGroup.js
// https://github.com/mui/material-ui/blob/master/packages/mui-material/src/RadioGroup/RadioGroup.d.ts
export const RadioGroup = createPolymorphicComponent(forwardRef(function RadioGroup(props, forwardedRef) {
    const { sx, children, onChange, value: valueProp, defaultValue, name: nameProp, ...other } = props;
    const hostRef = useRef(null);
    const [value, setValue] = useControlledValue({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup',
    });
    useImperativeHandle(forwardedRef, () => ({
        focus: () => {
            const input = hostRef.current?.querySelector('input:not(:disabled):checked') ??
                hostRef.current?.querySelector('input:not(:disabled)') ??
                undefined;
            if (input) {
                input.focus();
            }
        },
    }), []);
    const handleRef = useMergeRefs([forwardedRef, hostRef]);
    const name = useId(nameProp);
    const contextValue = useMemo(() => {
        return {
            name,
            onChange: (event, value) => {
                setValue(value);
                onChange?.(event, value);
            },
            value,
        };
    }, [name, onChange, value, setValue]);
    return (_jsx(RadioGroupContext.Provider, { value: contextValue, children: _jsx(Base, { sx: sx, role: 'radiogroup', "data-cy": 'radioGroup', ...other, ref: handleRef, children: children }) }));
}));
